var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.markentryConf.termConf.terms),function(term){return _c('singleTermWiseMarkentry',{key:term.id,attrs:{"markentry-conf":_vm.markentryConf,"term-conf":term},on:{"add-term-mark":_vm.addTermMark}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }